export default __webpack_public_path__ + "static/media/hero-login-bg.cbb8e612.jpg";